<template>
    <bs5-base-button variant="primary" size="sm">
        <i class="bi bi-pencil"></i> Edit
    </bs5-base-button>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "EditButton",
});
</script>